<template lang="pug">
OrderActionModal(v-if="show" :show="show" max-width="min(100vw - 2rem, 28rem)" @close="$emit('close')")
  template(slot="header")
    span.uppercase Rechazar cambio · {{ orderLabel }}

  .product-change-reject-modal
    p.product-change-reject-modal__hint Selecciona el motivo del rechazo:

    button.product-change-reject-modal__reason(
      v-for="reason in reasons"
      :key="reason.key"
      type="button"
      :disabled="busy"
      @click="selectReason(reason.key)"
    ) {{ reason.label }}
</template>

<script>
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'
import { PRODUCT_CHANGE_REJECT_REASONS } from '@/helpers/orderNovelty'

export default {
  name: 'ProductChangeRejectModal',

  components: {
    OrderActionModal
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: String,
      default: ''
    },
    busy: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      reasons: PRODUCT_CHANGE_REJECT_REASONS
    }
  },

  computed: {
    orderLabel () {
      return this.order || ''
    }
  },

  methods: {
    selectReason (reason) {
      if (this.busy) return
      this.$emit('reject', reason)
    }
  }
}
</script>

<style lang="stylus" scoped>
.product-change-reject-modal
  padding 0 1.5rem 1.5rem

.product-change-reject-modal__hint
  margin 0 0 1rem
  font-size .95rem
  opacity .85

.product-change-reject-modal__reason
  display block
  width 100%
  margin 0 0 .65rem
  padding .85rem 1rem
  border 1px solid var(--color-border)
  border-radius .35rem
  background var(--color-light)
  color var(--color-font-principal)
  font-size .95rem
  text-align left
  cursor pointer

  &:last-child
    margin-bottom 0

  &:disabled
    opacity .6
    cursor default

  &:not(:disabled):active
    opacity .85
</style>



// WEBPACK FOOTER //
// src/components/elements/order/ProductChangeRejectModal.vue